export const tokenText = "authToken"
export const getToken = () => localStorage.getItem(tokenText)
export const setToken = (value) => localStorage.setItem(tokenText, value)
export const removeToken = () => localStorage.removeItem(tokenText)
